import React from 'react';
import { Smile, Star, Heart } from 'lucide-react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-800">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 50px, rgba(251, 191, 36, 0.1) 50px, rgba(251, 191, 36, 0.1) 51px)`,
        }}></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(90deg, transparent, transparent 50px, rgba(251, 191, 36, 0.1) 50px, rgba(251, 191, 36, 0.1) 51px)`,
        }}></div>
      </div>

      {/* Flying Bee with Worker Hat */}
      <div className="bee-container">
        <div className="bee-with-hat">
          {/* Worker Hat */}
          <div className="worker-hat">
            <div className="hat-top"></div>
            <div className="hat-brim"></div>
          </div>
          {/* Bee Body */}
          <div className="bee-body">
            <div className="bee-stripe stripe-1"></div>
            <div className="bee-stripe stripe-2"></div>
            <div className="bee-stripe stripe-3"></div>
            <div className="bee-face">
              <div className="bee-eye left"></div>
              <div className="bee-eye right"></div>
              <div className="bee-smile"></div>
            </div>
          </div>
          {/* Wings */}
          <div className="bee-wings">
            <div className="wing left-wing"></div>
            <div className="wing right-wing"></div>
          </div>
        </div>
      </div>

      {/* Happy Customers */}
      <div className="customers-container">
        <div className="customer customer-1">
          <div className="customer-avatar">
            <Smile className="text-yellow-400" size={32} />
          </div>
          <div className="joy-indicator">
            <Star className="text-yellow-400" size={16} />
          </div>
        </div>
        <div className="customer customer-2">
          <div className="customer-avatar">
            <Smile className="text-yellow-400" size={32} />
          </div>
          <div className="joy-indicator">
            <Heart className="text-yellow-400" size={16} />
          </div>
        </div>
        <div className="customer customer-3">
          <div className="customer-avatar">
            <Smile className="text-yellow-400" size={32} />
          </div>
          <div className="joy-indicator">
            <Star className="text-yellow-400" size={16} />
          </div>
        </div>
        <div className="customer customer-4">
          <div className="customer-avatar">
            <Smile className="text-yellow-400" size={32} />
          </div>
          <div className="joy-indicator">
            <Heart className="text-yellow-400" size={16} />
          </div>
        </div>
      </div>

      {/* Content Overlay */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 animate-fade-in">
            Welcome to <span className="text-yellow-400">bHyyve</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto">
            Your trusted platform for connecting with quality businesses.
            Book services and order products instantly and experience excellence.
          </p>
          <div className="flex items-center justify-center gap-2 text-yellow-400 animate-pulse">
            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
            <p className="text-sm uppercase tracking-wider">Watch our bee deliver happiness</p>
            <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;